import { computed } from 'vue'
import OrionError from '../../../error/OrionError'

import camelize from '../../_antd_util/camelize'
import { filterEmpty } from '../../_antd_util'

function genColumns(children) {
  const tableColumns = children?.map((c) => {
    const props = { ...(c.props || {}) }
    for (const [k, v] of Object.entries(props)) {
      delete props[k]
      props[camelize(k)] = v
    }

    if (c.type.name === 'OQuerytableColumnIndex') {
      return {
        type: c.type.name,
      }
    } else if (c.type.name === 'OQuerytableColumnString' || c.type.name === 'OQuerytableColumnLink') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        children: c.children,
      }
    } else if (c.type.name === 'OQuerytableColumnNumber') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        thousandsSeparator: props?.thousandsSeparator,
        precision: Number(props?.precision),
        percentage: props?.percentage,

        children: c.children,
      }
    } else if (c.type.name === 'OQuerytableColumnDate') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        format: props?.format,
        sourceFormat: props?.sourceFormat,

        children: c.children,
      }
    } else if (c.type.name === 'OQuerytableColumnSingleselect' || c.type.name === 'OQuerytableColumnMultiselect') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        code: props?.code,

        children: c.children,
      }
    } else if (c.type.name === 'OQuerytableColumnButtongroup') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        children: c.children,
      }
    } else if (c.type.name === 'OQuerytableColumngroup') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,

        children: genColumns(filterEmpty(c.children?.default?.())),
      }
    } else if (c.type.name === 'OQuerytableColumnDiy') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        children: c.children,
      }
    } else {
      throw new OrionError(`OQuerytable不能正确解析'${c.type.name}'子组件。`)
    }
  })

  return tableColumns
}

export default function useColumns(slots) {
  const columns = computed(() => {
    const children = slots.default?.()

    const non_empty_children = filterEmpty(children)

    const tableColumns = genColumns(non_empty_children)

    return tableColumns
  })

  return columns
}
